import { createAppTestIds } from './index';

/**
 * Test IDs for Microsoft integration
 */
export const MICROSOFT_TEST_IDS = {
  ...createAppTestIds('microsoft'),
} as const;
